import { useQuery } from "@apollo/client";
import { PlatformMenuItemQuery } from "../graphql/queries";
import type { PlatformMenuItemQueryType } from "@/types/graphql/partner.generated";

export const usePlatformMenuItemQuery = (id: string) => {
  return useQuery<PlatformMenuItemQueryType>(PlatformMenuItemQuery, {
    variables: {
      id,
    },
    skip: !id,
  });
};
